<template>
  <div class="banner">
    <div class="empty" v-if="showEmpty">
      <img src="@/assets/img/arkHome/banner_out.png" alt="" />
    </div>
    <div id="root" class="root" v-if="bannerList.length" style="overflow: hidden">
      <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white" @change="onChange">
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          @click="jumpCourseDetail(index)"
        >
          <img :src="item.images" />
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { setBaseUrl, gioPlatform, gioJumpType,handleJumpType } from '@/utils/tools';

export default {
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
    examYear: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isVisual: true, // 可视区域
      flag_img: false,
      loginStatus: '',
      swiper: null,
      bannerShow: true,
      lastTime: null,
      gioType: 1, // 埋点类型 1广告点击,2广告曝光
      scroll: '',
      gioStop: false,
      showEmpty: true,
    };
  },
  created() {},
  watch: {
    bannerList() {
      this.showEmpty = false;
      if (!this.bannerList?.length) return;
      this.gioEvent(this.bannerList[0], 0, (this.gioType = 2));
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    jumpCourseDetail(index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent(this.bannerList[index], 1, (this.gioType = 1));
      this.lastTime = Date.now();
      handleJumpType(this, this.bannerList[index]);
    },
    onChange(index) {
      if (!this.gioStop) {
        this.gioEvent(this.bannerList[index], index, (this.gioType = 2));
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      const bodyHeight = document.getElementsByClassName('my-swipe')[0].offsetHeight;
      if (this.scroll > bodyHeight + 20) {
        // banner停止上报gio
        this.gioStop = true;
      } else {
        this.gioStop = false;
      }
    },
    gioEvent(course, index, type) {
      const { title, skipType } = course;
      const adId = course.id;
      if (type === 1) {
        // eslint-disable-next-line
        gio('evar.set', 'banner_evar', title);
        // 点击广告
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: this.$route.path === '/newUserZone' ? '新人注册活动banner' : `${this.examYear}考研-首页-banner`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: (index + 1).toString(), // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 点击广告
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: this.$route.path === '/newUserZone' ? '新人注册活动banner' : `${this.examYear}考研-首页-banner`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: (index + 1).toString(), // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.banner {
  padding: 0 40px;
  .empty {
    min-height: 300px;
    img {
      width: 100%;
      border-radius: 8px;
    }
  }
}

.root {
  width: 100% !important;
  margin-bottom: 20px;
  // border-radius: 0.1px;
  background-color: #fff;
  border-radius: 16px;
}
.my-swipe {
  width: 670px;
  height: 204px;
  overflow: visible !important;
  border-radius: 8px;
}
::v-deep .van-swipe__track,
::v-deep .van-swipe {
  border-radius: 8px;
}
.my-swipe .van-swipe-item img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  pointer-events: none;
}
::v-deep .van-swipe__indicators .van-swipe__indicator {
  width: 8px;
  height: 5px;
  background: rgba(58, 74, 94, 1);
  border-radius: 4px;
  opacity: 0.3;
}
::v-deep .van-swipe__indicators .van-swipe__indicator--active {
  width: 14px;
  height: 5px;
  background: rgba(58, 74, 94, 1);
  border-radius: 3px;
  opacity: 0.6;
}
</style>
